import request from '@/utils/request'

// 查询桥梁基础信息列表
export function listQljcxx(query) {
  return request({
    url: '/other/qljcxx/list',
    method: 'get',
    params: query
  })
}

// 查询桥梁基础信息详细
export function getQljcxx(id) {
  return request({
    url: '/other/qljcxx/' + id,
    method: 'get'
  })
}

// 新增桥梁基础信息
export function addQljcxx(data) {
  return request({
    url: '/other/qljcxx',
    method: 'post',
    data: data
  })
}

// 修改桥梁基础信息
export function updateQljcxx(data) {
  return request({
    url: '/other/qljcxx',
    method: 'put',
    data: data
  })
}

// 删除桥梁基础信息
export function delQljcxx(id) {
  return request({
    url: '/other/qljcxx/' + id,
    method: 'delete'
  })
}
